import { render, staticRenderFns } from "./WorkflowAssetPanelModal.vue?vue&type=template&id=390148a5&scoped=true"
import script from "./WorkflowAssetPanelModal.vue?vue&type=script&lang=js"
export * from "./WorkflowAssetPanelModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowAssetPanelModal.vue?vue&type=style&index=0&id=390148a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390148a5",
  null
  
)

export default component.exports